var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.72 1.21934C11.8606 1.07889 12.0512 1 12.25 1C12.4488 1 12.6394 1.07889 12.78 1.21934L20.28 8.71934C20.4205 8.85997 20.4993 9.05059 20.4993 9.24934C20.4993 9.44809 20.4205 9.63871 20.28 9.77934L12.78 17.2793C12.7113 17.353 12.6285 17.4121 12.5365 17.4531C12.4445 17.4941 12.3452 17.5162 12.2445 17.5179C12.1438 17.5197 12.0438 17.5012 11.9504 17.4635C11.857 17.4257 11.7722 17.3696 11.701 17.2984C11.6297 17.2272 11.5736 17.1423 11.5359 17.0489C11.4982 16.9555 11.4796 16.8555 11.4814 16.7548C11.4832 16.6541 11.5052 16.5548 11.5462 16.4628C11.5872 16.3708 11.6463 16.288 11.72 16.2193L17.94 9.99934H1.75C1.55109 9.99934 1.36032 9.92032 1.21967 9.77967C1.07902 9.63902 1 9.44825 1 9.24934C1 9.05043 1.07902 8.85966 1.21967 8.71901C1.36032 8.57836 1.55109 8.49934 1.75 8.49934H17.94L11.72 2.27934C11.5795 2.13871 11.5007 1.94809 11.5007 1.74934C11.5007 1.55059 11.5795 1.35997 11.72 1.21934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.593308d833734f7315d0577ac9f1c78c.svg";
export { ForwardRef as ReactComponent };